module.exports = __webpack_public_path__ + "img/left2.d40a784a.png";